import React, { useContext, useEffect } from "react";
import HeaderDesktop from "./HeaderDesktop";
import { ThemeContext } from "./context/theme-context";
import { AnimatePresence, motion } from "framer-motion";
import HeaderMobile from "./HeaderMobile";
// import AnimatedHeaderDesktop from "./AnimatedHeaderDesktop";

const Layout = ({ children, location }) => {
  const {
    layout,
    isOpen,
    isFirstTime,
    isProjectsOpen,
    setIsOpen,
    setIsProjectsOpen,
    isSingleProjectPage,
    setIsFirstTime,
    isAuxPage,
    isAuxMenuVisible,
    setIsAuxMenuVisible,
    setWhichHovered,
    auxMenuComponents,
    setHeaderHeight,
    width,
    header,
    mainRef,
    isMobileMenuOpen,
    setIsMobileMenuOpen,
  } = useContext(ThemeContext);

  useEffect(() => {
    setHeaderHeight(header.current.getBoundingClientRect().height);
  }, [width, isProjectsOpen, header, setHeaderHeight]);

  return (
    <div
      ref={layout}
      style={{
        minHeight: "100svh",
      }}
      className="flex flex-col font-body antialiased text-xl"
    >
      <div ref={header} className="fixed z-20 top-0 left-0 w-full ">
        <HeaderMobile
          setIsOpen={setIsOpen}
          isProjectsOpen={isProjectsOpen}
          isFirstTime={isFirstTime}
          setIsFirstTime={setIsFirstTime}
          width={width}
          isSingleProjectPage={isSingleProjectPage}
          pathname={location.pathname}
          setIsAuxMenuVisible={setIsAuxMenuVisible}
          auxMenuComponents={auxMenuComponents}
          isMobileMenuOpen={isMobileMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
        />
        {/* <AnimatedHeaderDesktop /> */}
        <HeaderDesktop
          isOpen={isOpen}
          isProjectsOpen={isProjectsOpen}
          setIsOpen={setIsOpen}
          setIsProjectsOpen={setIsProjectsOpen}
          pathname={location.pathname}
          isSingleProjectPage={isSingleProjectPage}
          setIsFirstTime={setIsFirstTime}
          isFirstTime={isFirstTime}
          isAuxPage={isAuxPage}
          isAuxMenuVisible={isAuxMenuVisible}
          setIsAuxMenuVisible={setIsAuxMenuVisible}
          setWhichHovered={setWhichHovered}
          auxMenuComponents={auxMenuComponents}
        />
      </div>
      <main ref={mainRef} className="h-[100%]">
        <AnimatePresence mode="popLayout">
          <motion.div
            key={location.pathname}
            initial={{
              opacity: 0,
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            }}
            animate={{ opacity: 1 }}
            exit={{
              opacity: 0,
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            }}
          >
            {children}
          </motion.div>
        </AnimatePresence>
      </main>
    </div>
  );
};

export default Layout;
